"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _colors = require("../colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createClassNames = function createClassNames(classNamesObject) {
  var classNames = [];
  Object.keys(classNamesObject).forEach(function (key) {
    if (classNamesObject[key]) {
      classNames.push(key);
    }
  });
  return classNames.join(' ');
};

var CarouselSlide =
/*#__PURE__*/
function (_Component) {
  _inherits(CarouselSlide, _Component);

  function CarouselSlide() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CarouselSlide);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CarouselSlide)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "isUnmounted", false);

    _defineProperty(_assertThisInitialized(_this), "state", {
      direction: null
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
      _this.props.onCarouselClick && _this.props.onCarouselClick(_this.props.index);
    });

    _defineProperty(_assertThisInitialized(_this), "startAnimation", function () {
      if (_this.isUnmounted) {
        return;
      }

      _this.setState({
        direction: _this.props.direction === 'prev' ? 'right' : 'left'
      });
    });

    return _this;
  }

  _createClass(CarouselSlide, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var active = this.props.active;
      var prevActive = prevProps.active;

      if (active !== prevActive) {
        setTimeout(function () {
          return _this2.startAnimation();
        }, 20);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.isUnmounted = true;
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      // eslint-disable-line camelcase
      if (this.props.active !== nextProps.active) {
        this.setState({
          direction: null
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          direction = _this$props.direction,
          active = _this$props.active,
          animateIn = _this$props.animateIn,
          animateOut = _this$props.animateOut,
          onCarouselClick = _this$props.onCarouselClick,
          showZoomOverlay = _this$props.showZoomOverlay;
      var classes = {
        item: true,
        clickable: onCarouselClick && active && !animateIn,
        active: active && !animateIn || animateOut,
        'overlay-container': showZoomOverlay
      };

      if (direction && active && animateIn) {
        classes[direction] = true;
      }

      if (this.state.direction && (animateIn || animateOut)) {
        classes[this.state.direction] = true;
      }

      return _react["default"].createElement("div", {
        onClick: this.onClick,
        className: createClassNames(classes)
      }, this.props.children, showZoomOverlay ? _react["default"].createElement("div", {
        className: "overlay flex-center"
      }, _react["default"].createElement(_Icon["default"], {
        name: "zoom-in-l",
        size: "2x",
        color: _colors.teal.base
      })) : null);
    }
  }]);

  return CarouselSlide;
}(_react.Component);

exports["default"] = CarouselSlide;
CarouselSlide.propTypes = {
  active: _propTypes["default"].bool,
  index: _propTypes["default"].number,
  animateOut: _propTypes["default"].bool,
  animateIn: _propTypes["default"].bool,
  direction: _propTypes["default"].string,
  onCarouselClick: _propTypes["default"].func,
  showZoomOverlay: _propTypes["default"].bool,
  children: _propTypes["default"].node
};